/// <amd-module name="Analytics/Boards/RollupQueries/Contracts" />
export enum RollupType {
    Progress,
    Total
}

export enum RollupAggregation {
    Count = 1,
    Sum = 2
}

export interface RollupCalculationSettings {
    workItemTypeFilter?: string;
    backlogFilter?: string;
    type: RollupType;
    aggregation: RollupAggregation;
    aggregationField?: string;
}
